import React, { useEffect } from "react";
import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    ticketHeader: {
        display: "flex",
        background: theme.palette.total,
        flex: "none",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        height: "55px",
        alignItems: "center", // Centraliza verticalmente
        justifyContent: "center", // Centraliza horizontalmente
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            height: 'max-content'
        },
    },
    backButton: {
        minWidth: "40px",
        padding: "15px",
        display: "flex", // Adiciona flexbox
        justifyContent: "center", // Centraliza horizontalmente
        alignItems: "center", // Centraliza verticalmente
    },
    backIcon: {
        fontSize: "25px", // Diminui tamanho da seta
		alignItems: "center", // Centraliza verticalmente
        justifyContent: "center", // Centraliza horizontalmente
    },
    contentWrapper: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
        marginLeft: "-10px", // Adiciona um deslocamento negativo para aproximar os elementos
    }
}));

const TicketHeader = ({ loading, children }) => {
    const classes = useStyles();
    const history = useHistory();

    const handleBack = () => {
        history.push("/tickets");
    };


	//ao apertar tecla "ESC" na conversa ela sai daquele atendimento.
	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === "Escape") {
				handleBack();
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [history]);

    return (
        <>
            {loading ? (
                <TicketHeaderSkeleton />
            ) : (
                <Card square className={classes.ticketHeader}>
                    <Button 
                        color="primary" 
                        onClick={handleBack} 
                        className={classes.backButton}
                    >
                        <ArrowBackIos className={classes.backIcon} />
                    </Button>
                    <div className={classes.contentWrapper}>
                        {children}
                    </div>
                </Card>
                
            )}
        </>
    );
};

export default TicketHeader;
